import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormItem } from '../form-item';

@Component({
  selector: 'app-form-item',
  templateUrl: './form-item.component.html',
  styleUrls: ['./form-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormItemComponent implements OnInit {
  @Input()
  formItem!: FormItem<string>;
  @Input()
  form!: FormGroup;

  constructor() {}

  ngOnInit(): void {}

  get isValid(): boolean {
    return this.form.controls[this.formItem.key].valid;
  }
}
